'use strict';

angular.module('mean.admin-panel').controller('TradeAdminController', ['$scope', '$state', 'Users', 'Global', 'MeanUser', '$location', 'toaster', '$q', 'AdminPanel', 'ngDialog',
  function ($scope, $state, Users, Global, MeanUser, $location, toaster, $q, AdminPanel, ngDialog) {
    $scope.global = Global;
    $scope.package = {
      name: 'admin-panel'
    };

    console.log('TradeAdminController');

    $scope.user = MeanUser.user;
    $scope.accountPassword = null;

    for (var i = 0; i < $scope.user.roles.length; i++) {
      if ($scope.user.roles[i] === 'tm_admin') {
        $scope.tm_admin = true;
      }
    }

    if (!$scope.tm_admin) {
      toaster.pop('error', 'Admin Panel', 'You do not have the proper permissions for this page.');
      $location.path('home');
      return;
    }

    $scope.authAccount = () => {
      ngDialog.openConfirm({
        template: 'admin-panel/views/account-password-popup.html',
        scope: $scope,
        className: 'ngdialog-theme-default ngdialg-padding ngdialog-sm'
      }).then(function (value) {
        Users.query({
          type: 'accountLogin',
          password: value
        }, function (users) {
          if (users.length) {
            localStorage.setItem('accessgranted', true);
            $state.go('accounting');
          } else {
            toaster.pop('error', 'Login Failed', 'Please enter correct password.');
          }
        })

      }, function (value) {
        $scope.accountPassword = null;
      });
    }

  }
]);



// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/controllers/tradeAdminPanel.js